(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovo-about-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const INTERVAL = 1000; 

  document.querySelectorAll('.ovo-about-hero__timeline').forEach((timeline) => {
    const items = Array.from(timeline.querySelectorAll('.ovo-about-hero__timeline-item'));
    if (items.length < 2) return;

    let current = 0;
    let timer = null;
    let paused = false;

    const setActive = (idx) => {
      items.forEach((item, i) => {
        item.classList.toggle('is-active', i === idx);
      });
      current = idx;
    };

    const next = () => {
      setActive((current + 1) % items.length);
    };

    const startTimer = () => {
      clearInterval(timer);
      timer = setInterval(next, INTERVAL);
    };

    const stopTimer = () => {
      clearInterval(timer);
    };

    // Auto-start
    startTimer();

    // Hover — pause auto, highlight hovered item
    items.forEach((item, i) => {
      item.addEventListener('mouseenter', () => {
        paused = true;
        stopTimer();
        setActive(i);
      });
      item.addEventListener('mouseleave', () => {
        paused = false;
        startTimer();
      });
      // Click — same as hover but stays until next auto tick
      item.addEventListener('click', () => {
        setActive(i);
        startTimer(); // reset timer from this item
      });
    });

    // Pause when tab not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopTimer();
      } else if (!paused) {
        startTimer();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovo-capabilities-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    document.querySelectorAll('.capabilities').forEach((section) => {
      const cards = Array.from(section.querySelectorAll('.cap-card--has-hover-image'));

      cards.forEach((card) => {
        card.addEventListener('click', (event) => {
          if (canHover.matches) return;

          const link = card.querySelector('.cap-card__link');
          const isLinkClick = link && event.target === link;
          if (isLinkClick && card.classList.contains('is-active')) return;

          event.preventDefault();
          cards.forEach((otherCard) => {
            if (otherCard !== card) otherCard.classList.remove('is-active');
          });
          card.classList.toggle('is-active');
        });

        card.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          if (canHover.matches) return;

          event.preventDefault();
          cards.forEach((otherCard) => {
            if (otherCard !== card) otherCard.classList.remove('is-active');
          });
          card.classList.toggle('is-active');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovo-client-proof"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {


document.querySelectorAll('.ovo-client-proof__carousel').forEach((carousel) => {
  const slides = Array.from(carousel.querySelectorAll('.ovo-client-proof__slide'));
  const dots   = Array.from(carousel.querySelectorAll('label.ovo-client-proof__dot'));
  if (!slides.length) return;

  let current = 0;

  const goTo = (index) => {
    // Previous hide
    slides[current].style.display = 'none';
    dots[current].style.opacity = '0.75';
    dots[current].style.backgroundColor = '#9CCFFF';

    // New show
    current = index;
    slides[current].style.display = 'block';
    dots[current].style.opacity = '1';
    dots[current].style.backgroundColor = '#1F85E4';
  };

  // Init — first slide show
  slides.forEach((s, i) => s.style.display = i === 0 ? 'block' : 'none');
  if (dots[0]) {
    dots[0].style.backgroundColor = '#1F85E4';
    dots[0].style.opacity = '1';
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', (e) => {
      goTo(i);
    });
    dot.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      goTo(i);
    });
  });
});
    // Marquee setup — always wrap in track, CSS controls behavior per breakpoint
    document.querySelectorAll('.ovo-client-proof__logo-row').forEach((row) => {
      if (row.dataset.marqueeInit) return;
      row.dataset.marqueeInit = '1';

      const logos = Array.from(row.children);
      if (!logos.length) return;

      const track = document.createElement('div');
      track.className = 'ovo-cp-track';
      logos.forEach(logo => track.appendChild(logo));

      // Clone only for mobile marquee loop
      const clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');

      row.appendChild(track);
      row.appendChild(clone);
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovo-hero-cards"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.ovo-hero-cards').forEach((root) => {
    const toggle = root.querySelector('.ovo-hero-cards__mobile-toggle');
    const menu   = root.querySelector('.ovo-hero-cards__mobile-menu');

    if (toggle && menu) {
      let savedScrollY = 0;

      const closeMenu = () => {
        root.classList.remove('ovo-hero-cards--menu-open');
        toggle.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        document.body.style.position = '';
        document.body.style.top      = '';
        document.body.style.width    = '';
        document.body.style.overflow = '';
        window.scrollTo(0, savedScrollY);
      };

      const openMenu = () => {
        savedScrollY = window.scrollY || window.pageYOffset;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top      = `-${savedScrollY}px`;
        document.body.style.width    = '100%';
        root.classList.add('ovo-hero-cards--menu-open');
        toggle.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');
      };

      toggle.addEventListener('click', () => {
        root.classList.contains('ovo-hero-cards--menu-open') ? closeMenu() : openMenu();
      });

      root.querySelectorAll('.ovo-hero-cards__mobile-links a, .ovo-hero-cards__mobile-cta')
        .forEach(link => link.addEventListener('click', closeMenu));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && root.classList.contains('ovo-hero-cards--menu-open')) {
          closeMenu();
          toggle.focus();
        }
      });
    }

    /* ---- Dot carousel logic ---- */
    const track = root.querySelector('.ovo-hero-cards__grid');
    const cards = Array.from(root.querySelectorAll('.ovo-hero-cards__card-shell'));
    const dots  = Array.from(root.querySelectorAll('.ovo-hero-cards__dot'));
    if (!track || cards.length < 2 || dots.length !== cards.length) return;

    let scrollFrame = null;

    const getCardLeft   = (card) => card.offsetLeft - track.offsetLeft;
    const getActiveIndex = () => {
      const cur = track.scrollLeft;
      return cards.reduce((best, card, i) =>
        Math.abs(getCardLeft(card) - cur) < Math.abs(getCardLeft(cards[best]) - cur) ? i : best
      , 0);
    };

    const setActiveDot = (idx) => {
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === idx);
        i === idx ? dot.setAttribute('aria-current','true') : dot.removeAttribute('aria-current');
      });
    };

    const scrollToCard = (idx) => {
      const card = cards[idx];
      if (!card) return;
      track.scrollTo({
        left: getCardLeft(card),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      setActiveDot(idx);
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => scrollToCard(i)));

    track.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        setActiveDot(getActiveIndex());
        scrollFrame = null;
      });
    }, { passive: true });

    window.addEventListener('resize', () => setActiveDot(getActiveIndex()), { passive: true });
    setActiveDot(0);

  }); // ← forEach closes here — dot carousel is INSIDE it
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovo-industries"] && !Shopify.designMode) return;
  try {
    
(function () {
  const toggle = document.querySelector('.ovo-industries__mobile-toggle');
  const mobileNav = document.querySelector('.ovo-industries__mobile-nav');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
      mobileNav.hidden = expanded;
    });
  }

  const allLinks = document.querySelectorAll('.ovo-industries__nav-link');
  const items = document.querySelectorAll('.ovo-industries__item');

  if (!allLinks.length || !items.length) return;

  function setActive(id) {
    allLinks.forEach((link) => {
      link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
    });
  }

  let isClickScrolling = false;
  let clickScrollTimeout;

  allLinks.forEach((link) => {
    link.addEventListener('click', () => {
      const id = link.getAttribute('href').slice(1);
      setActive(id);

      // mobile menu close on link click
      if (toggle && mobileNav && !mobileNav.hidden) {
        toggle.setAttribute('aria-expanded', 'false');
        mobileNav.hidden = true;
      }

      // observer ni konchem sepu pause chesi, click తర్వాత
      // active state click చేసిన link meeda స్థిరంగా ఉండేలా చూస్తుంది
      isClickScrolling = true;
      clearTimeout(clickScrollTimeout);
      clickScrollTimeout = setTimeout(() => {
        isClickScrolling = false;
      }, 700);
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      if (isClickScrolling) return;
      entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)
        .forEach((entry, i) => {
          if (i === 0) setActive(entry.target.id);
        });
    },
    { rootMargin: '0px 0px -60% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] }
  );

  items.forEach((item) => observer.observe(item));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovo-value-added-services"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.ovo-value-services').forEach((section) => {
      const tabs = Array.from(section.querySelectorAll('.ovo-value-services__tab'));
      const panels = Array.from(section.querySelectorAll('.ovo-value-services__panel'));

      const activate = (panelName) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.panel === panelName;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const active = panel.dataset.panel === panelName;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activate(tab.dataset.panel));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
